import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResalepageComponent } from './resalepage.component';



const routes: Routes = [
    {
        path: '',
        component: ResalepageComponent,
        data: {
            title: 'Resale Page'
        }
    },
    {
        path: ':id/:actionInfo',
        component: ResalepageComponent,
        data: {
            title: 'Resale Page'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class  ResalePageRoutingModule { }
